// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media(min-width:768px) and (max-width: 991px){
    div[id='contact-form']{
        padding-left: 50px;
        padding-right: 50px;
    }
}
div[id='root'] {
    background-color: white;
}

.contact-form .contact-form-input {
    height: 57px;
    border-radius: 5px;
    border: 1px solid rgba(171, 152, 186, 0.5);
    margin-top: 0 !important;
    margin-bottom: 36px !important;
}

.contact-form .contact-form-input-textarea {
    height: 137px;
}

.contact-form .contact-form-input label {
    font-size: 13px;
    color: rgb(171, 152, 186)
}

div[role='radiogroup'] {
    margin-bottom: 36px;
}

.contact-form .contact-form-checkbox-label {
    margin-left: 0;
    margin-bottom: 36px;
}

.contact-form .contact-form-checkbox-label svg {
    color: #9E77ED;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    margin-right: 14px;
}

.contact-form .contact-form-checkbox-label span {
    font-size: 14px;
    color: #000;
    padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/contact/components/ContactForm.css"],"names":[],"mappings":";AACA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,UAAU;AACd","sourcesContent":["\n@media(min-width:768px) and (max-width: 991px){\n    div[id='contact-form']{\n        padding-left: 50px;\n        padding-right: 50px;\n    }\n}\ndiv[id='root'] {\n    background-color: white;\n}\n\n.contact-form .contact-form-input {\n    height: 57px;\n    border-radius: 5px;\n    border: 1px solid rgba(171, 152, 186, 0.5);\n    margin-top: 0 !important;\n    margin-bottom: 36px !important;\n}\n\n.contact-form .contact-form-input-textarea {\n    height: 137px;\n}\n\n.contact-form .contact-form-input label {\n    font-size: 13px;\n    color: rgb(171, 152, 186)\n}\n\ndiv[role='radiogroup'] {\n    margin-bottom: 36px;\n}\n\n.contact-form .contact-form-checkbox-label {\n    margin-left: 0;\n    margin-bottom: 36px;\n}\n\n.contact-form .contact-form-checkbox-label svg {\n    color: #9E77ED;\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n    margin-right: 14px;\n}\n\n.contact-form .contact-form-checkbox-label span {\n    font-size: 14px;\n    color: #000;\n    padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
